import React, { useState, useEffect } from 'react';
import { useIsMobile } from '../hooks/use-mobile';
import LendoMenuMobile from './LendoMenuMobile';
import LendoMenuDesktop from './LendoMenuDesktop';
import LendoIcon from './LendoIcon';
import './LendoMenu.css';

const LendoMenu = () => {
  const [isOpen, setIsOpen] = useState(false);
  const isMobile = useIsMobile();

  useEffect(() => {
    if (isOpen) {
      // Calculate scrollbar width before hiding
      const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;

      // Prevent scrolling while preserving scrollbar space
      document.body.style.overflow = 'hidden';
      document.body.style.backgroundColor = 'white';
      document.body.style.paddingRight = `${scrollbarWidth}px`;
    } else {
      // Restore normal scrolling
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';
    }

    // Cleanup function
    return () => {
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';
    };
  }, [isOpen]);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <button className="menu-toggle" onClick={toggleMenu}>
        {isOpen ? (
          <div className="menu-icon-wrapper">
            <span>Lukk</span>
              <LendoIcon name="icon/close-menu" size='15px'/>
          </div>
        ) : (
          <div className="menu-icon-wrapper">
            <span>Meny</span>
              <LendoIcon name="icon/menu" size='20px' />
          </div>
        )}
      </button>
      {isOpen && (
        <>
          <div className="menu-backdrop" onClick={toggleMenu} />
          <div className="menu-container">
            <div className="menu-content">
              {isMobile ? <LendoMenuMobile /> : <LendoMenuDesktop />}
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default LendoMenu;
